/**
 * Single source of truth for store-scoped channel identifiers.
 *
 * Each value must match the `categoryKey` of a top-level Commercetools category
 * that acts as the navigation root for that store.
 *
 * Add a new entry here when onboarding a second store. TypeScript will propagate
 * the updated union to every call site via the StoreChannel type.
 *
 * Imported by:
 *   - backend: packages/ecommdev/backend/.../utils/storeChannels.ts  (as VALID_CHANNELS)
 *   - frontend: packages/ecommdev/frontend/.../constants/storeChannels.ts (as STORE_CHANNELS)
 */
export const STORE_CHANNEL_LIST = ['viewrail'] as const;
export type StoreChannel = (typeof STORE_CHANNEL_LIST)[number];
